// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.holiday-theme__background-img{display:none}@media (min-width:1024px){.holiday-theme__background-img{display:block;position:absolute;z-index:-1;top:0;bottom:0;width:18rem}}@media (min-width:1024px){.holiday-theme__background-img-left{left:0;background-position:100% 0}}@media (min-width:1024px){.holiday-theme__background-img-right{right:0;background-position:0 0}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
